/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import { memo, useEffect, useState } from 'react'
import { Stack } from '@maas-components/core'
import { Form, Formik } from 'formik'
import * as Analytics from 'core/common/analytics'
import i18n from 'core/common/i18n'
import CardStep from 'core/components/CardStep'
import { Button } from 'core/components/Core'
import { useFormContext } from 'core/pages/ProductNew-v2/context/ProductNewContext'
import ProductTextEditor from '../ProductDescription/components/ProductTextEditor'
import ProductRelevanceCallout from '../ProductRelevanceCallout'
import { getDescriptionFormSchema } from './schema'

const ProductDescriptionForm = ({
  onNext,
  isEditMode,
  onEditSubmit,
  custom,
  handleEditStep,
  step,
  formMode,
}) => {
  const { formData, setFormData } = useFormContext()
  const initialValues = { description: formData.description }
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [onReload, setOnReload] = useState(0)
  const [textEditorKey, setTextEditorKey] = useState(0)

  useEffect(() => {
    const submitEdit = async () => {
      if (isSubmitting && isEditMode && onEditSubmit) {
        setIsSubmitting(false)
        setIsLoading(true)
        try {
          await onEditSubmit(formData)
          setIsLoading(false)
        } catch (error) {
          console.error('Error during API call', error)
        } finally {
          setIsLoading(false)
        }
      }
    }

    submitEdit()
  }, [isSubmitting, formData, isEditMode, onEditSubmit])

  const onSubmit = values => {
    Analytics.ProductDescriptionSaved(formMode)
    setFormData(prevData => ({ ...prevData, description: values.description.trim() }))

    setIsSubmitting(true)
    onNext()
  }

  const handleValidation = async ({ validateForm }) => {
    const errors = await validateForm()

    if (errors.description) {
      Analytics.ProductDescriptionValidationError(formMode)
    }
  }

  useEffect(() => {
    // eslint-disable-next-line no-param-reassign
    setOnReload(prev => prev++)
  }, [])

  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={initialValues}
      validationSchema={getDescriptionFormSchema(custom?.maxLimit ?? 5000)}
      enableReinitialize
    >
      {({ handleSubmit, dirty, resetForm, validateForm }) => {
        return (
          <Form className="w-100">
            <CardStep
              description={i18n.t('productNew.publication.description')}
              title={!isEditMode && i18n.t('productNew.publication.title')}
            >
              <ProductRelevanceCallout
                recommendations={[i18n.t('productNew.publication.relevanceRecommendation')]}
                disableScoreInfo={custom?.disableScoreInfo}
                onClick={() => Analytics.ProductDescriptionRelevanceClicked(formMode)}
              />

              <ProductTextEditor
                key={textEditorKey}
                onNext={onNext}
                onReload={onReload}
                custom={custom}
                hasHtmlFormat={custom ? !custom.disabledHtmlFormat : true}
                onChange={() => handleEditStep(step.key)}
              />

              <Stack className="mt-3" direction="row" justifyContent="flex-end" spacing={2}>
                {!isEditMode && (
                  <>
                    <Button
                      variant="text"
                      color="primary"
                      onClick={() => {
                        resetForm()
                        setTextEditorKey(prev => prev + 1)
                        handleEditStep(null)
                      }}
                      className="mr-2"
                    >
                      <span>Cancelar</span>
                    </Button>

                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        handleSubmit()
                        handleValidation({ validateForm })
                      }}
                    >
                      {i18n.t('productNew.actions.continue')}
                    </Button>
                  </>
                )}

                {isEditMode && (dirty || isLoading) && (
                  <>
                    <Button
                      variant="text"
                      color="primary"
                      onClick={() => resetForm()}
                      className="mr-2"
                    >
                      <span>Cancelar</span>
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        handleSubmit()
                        handleValidation({ validateForm })
                      }}
                      loading={isLoading}
                    >
                      <span>Salvar</span>
                    </Button>
                  </>
                )}
              </Stack>
            </CardStep>
          </Form>
        )
      }}
    </Formik>
  )
}

export default memo(ProductDescriptionForm)
